var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Carousel',_vm._b({scopedSlots:_vm._u([(_vm.checkLayoutMatch('layout_2'))?{key:"bottomBar",fn:function(slotProps){return [_c('Footer',{attrs:{"title":_vm.getTitleFromSlotProp(slotProps),"content":_vm.getTextFromSlotProp(slotProps)}})]}}:null],null,true)},'Carousel',_vm.createProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }